import React, {
  Dispatch,
  PropsWithChildren,
  ReactElement,
  SetStateAction,
} from 'react';
import classNames from 'classnames';
import { useTheme } from '../../../CiscoUi/providers/theme';
import styles from './CustomIcon.module.css';

export interface CustomIconProps {
  title?: string;
  onSelect: Dispatch<SetStateAction<string>>;
  isSelected: boolean;
}

export function CustomIcon({
  children,
  title,
  isSelected,
  onSelect,
}: PropsWithChildren<CustomIconProps>): ReactElement {
  const [theme] = useTheme();
  const isLightTheme = theme === 'light';

  return (
    <div
      onClick={() => onSelect(title || '')}
      className={classNames(
        styles.root,
        isSelected ? styles.isCustomIconSelected : '',
        isLightTheme ? styles.lightIcon : styles.darkIcon,
      )}
      data-testid={`custom-icon-${title}`}
    >
      <div className={styles.iconImage}>{children}</div>
      <p className={styles.iconLabel}>{title}</p>
    </div>
  );
}
